import { APPLICATION_TYPES } from '@/constants/applications'
import { ApplicationsState } from '@/state'
import { applicationsStateActions } from '@/state/actions'
import { Select } from 'antd'

export default function ApplicationsTypeFilter() {
  return (
    <Select
      value={ApplicationsState.filters.value.type}
      className='type-filter'
      options={APPLICATION_TYPES}
      allowClear
      onChange={applicationsStateActions.setApplicationTypeFilter}
      filterOption={(input, option) =>
        !!option && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      placeholder='Filtro por tipo'
      disabled={ApplicationsState.loading.value.getAll}
    />
  )
}
